export const PACKING_TYPES = [
    undefined,
    'bundles',
    'pallets',
    'sling bags',
    'bags',
    'jumbo bags',
    'big bags',
    'boxes',
    'containers',
    'crates',
    'cases',
    'trays',
    'bales',
    'barrels',
    'drums',
    'rolls',
    'coils',
    'cages',
    'packages',
];



// WEBPACK FOOTER //
// ./app/constants/packingType.js